import { createStructuredSelector } from 'reselect'

import {
   REQUEST_DETAIL_LIST,
   REQUEST_DETAIL_LIST_SUCCESS, 
   REQUEST_DETAIL_LIST_ERROR,
   REQUEST_DETAIL_PAGE_SET,
   REQUEST_DETAIL_SEARCH_SET,
   REQUEST_DETAIL_SEARCH_CHANGE,
   REQUEST_DETAIL_SEARCH_DELIVERY_ORDER_LINE_LOT,
   REQUEST_DETAIL_SEARCH_DELIVERY_ORDER_LINE_LOT_SUCCESS,
   REQUEST_DETAIL_SEARCH_DELIVERY_ORDER_LINE_LOT_ERROR, 
   REQUEST_DETAIL_ADD_SET,
   REQUEST_DETAIL_ADD_MODAL_SET,
   REQUEST_DETAIL_ADD,
   REQUEST_DETAIL_ADD_SUCCESS,
   REQUEST_DETAIL_ADD_ERROR,
   REQUEST_DETAIL_ADD_CHANGE,
   REQUEST_DETAIL_DETAIL,
   REQUEST_DETAIL_DETAIL_SUCCESS,
   REQUEST_DETAIL_DETAIL_ERROR,
   REQUEST_DETAIL_VIEW_MODAL_SET,
   REQUEST_DETAIL_EDIT_CHANGE,
   REQUEST_DETAIL_EDIT_MODAL_SET,
   REQUEST_DETAIL_UPDATE,
   REQUEST_DETAIL_UPDATE_SUCCESS,
   REQUEST_DETAIL_UPDATE_ERROR,
   REQUEST_DETAIL_VIEW_TAB_SET,
   REQUEST_DETAIL_UPLOAD_SET,
   REQUEST_DETAIL_UPLOAD_SET_SUCCESS,
   REQUEST_DETAIL_UPLOAD_SET_ERROR,
   REQUEST_DETAIL_UPLOAD_RESET
} from '../actions';

export const REQUEST_DETAIL_NAME = 'request_detail';
const NAME = REQUEST_DETAIL_NAME;

export const RequestDetailList = (page, num_page, orderBy, filters, stateFilter, display) => ({
  type:  REQUEST_DETAIL_LIST,
  payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter, display: display }
});

export const RequestDetailListSuccess = (data) => ({
  type:  REQUEST_DETAIL_LIST_SUCCESS,
  payload: data
});

export const RequestDetailListError = (error) => ({
  type:  REQUEST_DETAIL_LIST_ERROR,
  payload: error
});

export const RequestDetailPageSet = (data) => ({
  type:  REQUEST_DETAIL_PAGE_SET,
  payload: data
});

export const RequestDetailSearchSet = (data) => ({
  type:  REQUEST_DETAIL_SEARCH_SET,
  payload: data
});

export const RequestDetailSearchChangeSet = (data) => ({
  type:  REQUEST_DETAIL_SEARCH_CHANGE,
  payload: data
});

export const RequestDetailSearchDeliveryOrderLineLot = (data) => ({
  type:  REQUEST_DETAIL_SEARCH_DELIVERY_ORDER_LINE_LOT,
  payload: data
});

export const RequestDetailSearchDeliveryOrderLineLotSuccess = (message) => ({
  type:  REQUEST_DETAIL_SEARCH_DELIVERY_ORDER_LINE_LOT_SUCCESS,
  payload: message
});

export const RequestDetailSearchDeliveryOrderLineLotError = (error) => ({
  type:  REQUEST_DETAIL_SEARCH_DELIVERY_ORDER_LINE_LOT_ERROR,
  payload: error
}); 

export const RequestDetailAddChangeSet = (data) => ({
  type:  REQUEST_DETAIL_ADD_CHANGE,
  payload: data
});

export const RequestDetailAddSet = (data) => ({
  type:  REQUEST_DETAIL_ADD_SET,
  payload: data
});

export const RequestDetailAddModalSet = (data) => ({
  type:  REQUEST_DETAIL_ADD_MODAL_SET,
  payload: data
});

export const RequestDetailAdd = (data) => ({
  type:  REQUEST_DETAIL_ADD,
  payload: data
});

export const RequestDetailAddSuccess = (message) => ({
  type:  REQUEST_DETAIL_ADD_SUCCESS,
  payload: message
});

export const RequestDetailAddError = (error) => ({
  type:  REQUEST_DETAIL_ADD_ERROR,
  payload: error
});

export const RequestDetailDetail = (data) => ({
  type:  REQUEST_DETAIL_DETAIL,
  payload: data
});

export const RequestDetailDetailSuccess = (data) => ({
  type:  REQUEST_DETAIL_DETAIL_SUCCESS,
  payload: data
});

export const RequestDetailDetailError = (error) => ({
  type:  REQUEST_DETAIL_DETAIL_ERROR,
  payload: error
});

export const RequestDetailViewModalSet = (data) => ({
  type:  REQUEST_DETAIL_VIEW_MODAL_SET,
  payload: data
});

export const RequestDetailEditModalSet = (data) => ({
  type:  REQUEST_DETAIL_EDIT_MODAL_SET,
  payload: data
});

export const RequestDetailEditChangeSet = (data) => ({
  type:  REQUEST_DETAIL_EDIT_CHANGE,
  payload: data
});

export const RequestDetailUpdate = (data) => ({
  type:  REQUEST_DETAIL_UPDATE,
  payload: data
});

export const RequestDetailUpdateSuccess = (message) => ({
  type:  REQUEST_DETAIL_UPDATE_SUCCESS,
  payload: message.message
});

export const RequestDetailUpdateError = (error) => ({
  type:  REQUEST_DETAIL_UPDATE_ERROR,
  payload: error
});

export const RequestDetailViewTabSet = (data) => ({
  type:  REQUEST_DETAIL_VIEW_TAB_SET,
  payload: data
});

export const RequestDetailUploadSet = (file) => ({
  type:  REQUEST_DETAIL_UPLOAD_SET,
  payload: { file },
});

export const RequestDetailUploadSetSuccess = (items) => ({
  type:  REQUEST_DETAIL_UPLOAD_SET_SUCCESS,
  payload: items,
});

export const RequestDetailUploadSetError = (error) => ({
  type:  REQUEST_DETAIL_UPLOAD_SET_ERROR,
  payload: error,
});

export const RequestDetailUploadReset= () => ({
  type:  REQUEST_DETAIL_UPLOAD_RESET
});

const request_detail = (state) => state[NAME];

export const RequestDetailSelector = createStructuredSelector({
  request_detail
})
 